import DateService, { FMT, DayjsUnit } from "./DateService";
import { removeTildes } from "./FunctionHelper";
const construirBuild = (idSector, idRecurso, idRecursoSectorEstadoTipo, fecha) => ({
    recursoSector: {
        ID_SECTOR: idSector,
        ID_RECURSO: idRecurso
    },
    recursoEstado: {
        ID_RECURSO_SECTOR_ESTADO_TIPO: idRecursoSectorEstadoTipo,
        FECHA: fecha ? DateService.toDayjs(fecha).subtract(1, 'second').format(FMT.display) : DateService.getCurrentDayJs().format(FMT.display)
    },
    isReasignment: false
});
const SA = (estadoActual, emergenciaEstado, idSector, idRecurso, idRecursoSectorEstadoTipo, fecha) => {
    const condiciones = ['ASIGNADO'].includes(estadoActual);
    return {
        condiciones,
        build: construirBuild(idSector, idRecurso, idRecursoSectorEstadoTipo, fecha)
    };
};
const IN = (estadoActual, emergenciaEstado, idSector, idRecurso, idRecursoSectorEstadoTipo, fecha) => {
    const val = emergenciaEstado?.EMERGENCIA_ESTADO_TIPO?.VALUE ?? -1;
    const condiciones = (estadoActual === 'SALIDA AL INCIDENTE' && [0, 1].includes(val)) ||
        (estadoActual === 'SALIDA AL INCENDIO' && [0, 1, 2].includes(val));
    return {
        condiciones,
        build: construirBuild(idSector, idRecurso, idRecursoSectorEstadoTipo, fecha)
    };
};
const LI = (estadoActual, emergenciaEstado, idSector, idRecurso, idRecursoSectorEstadoTipo, fecha) => {
    const val = emergenciaEstado?.EMERGENCIA_ESTADO_TIPO?.VALUE ?? -1;
    const condiciones = estadoActual === 'SALIDA AL INCENDIO' && val === 3;
    return {
        condiciones,
        build: construirBuild(idSector, idRecurso, idRecursoSectorEstadoTipo, fecha)
    };
};
const RE = (estadoActual, emergenciaEstado, idSector, idRecurso, idRecursoSectorEstadoTipo, fecha) => {
    const val = emergenciaEstado?.EMERGENCIA_ESTADO_TIPO?.VALUE ?? -1;
    const condiciones = ((estadoActual === 'EN INCENDIO' || estadoActual === 'LIQUIDACION') && [1, 2, 3, 4].includes(val)) ||
        (estadoActual === 'EN INCIDENTE' && val === 1);
    return {
        condiciones,
        build: construirBuild(idSector, idRecurso, idRecursoSectorEstadoTipo, fecha)
    };
};
const RG = (estadoActual, emergenciaEstado, idSector, idRecurso, idRecursoSectorEstadoTipo, fecha) => {
    const estados1 = ['SALIDA AL INCENDIO', 'EN INCENDIO', 'LIQUIDACION', 'RETIRADA'];
    const estados2 = ['SALIDA AL INCIDENTE', 'EN INCIDENTE', 'RETIRADA'];
    const condiciones = estados1.includes(estadoActual) || estados2.includes(estadoActual);
    return {
        condiciones,
        build: construirBuild(idSector, idRecurso, idRecursoSectorEstadoTipo, fecha)
    };
};
const BA = (estadoActual, emergenciaEstado, idSector, idRecurso, idRecursoSectorEstadoTipo, fecha) => {
    const estados = [
        'ASIGNADO',
        'SALIDA AL INCENDIO',
        'SALIDA AL INCIDENTE',
        'EN INCENDIO',
        'EN INCIDENTE',
        'LIQUIDACION',
        'RETIRADA',
        'REGRESO'
    ];
    const condiciones = estados.includes(estadoActual);
    return {
        condiciones,
        build: construirBuild(idSector, idRecurso, idRecursoSectorEstadoTipo, fecha)
    };
};
const RAS = (estadoActual, emergenciaEstado, idSector, idRecurso, idRecursoSectorEstadoTipo, fecha) => {
    const estados = [
        'ASIGNADO',
        'SALIDA AL INCENDIO',
        'SALIDA AL INCIDENTE',
        'EN INCENDIO',
        'EN INCIDENTE',
        'LIQUIDACION',
        'RETIRADA',
        'REGRESO'
    ];
    const condiciones = estados.includes(estadoActual);
    const build = construirBuild(idSector, idRecurso, idRecursoSectorEstadoTipo, fecha);
    // Indicar que es una reasignación
    build.isReasignment = true;
    return {
        condiciones,
        build
    };
};
// ---------- Mapeo central ----------
const getAccion = { SA, IN, LI, RE, RG, BA, RAS };
// ---------- Builder central ----------
export function buildPeticionAccion({ action, estadoInicial, recursosSelected, arrayPeticiones, recursoEstadoTipos, emergenciaEstado, esIncendio, fechaBase }) {
    const { CODIGO, NOMBRE } = action;
    let nombreAccion = NOMBRE;
    // Ajustes de nombre según acción
    if (CODIGO === "BA" || CODIGO === "RAS") {
        nombreAccion = "Desasignado";
    }
    else if (esIncendio) {
        if (CODIGO === "SA")
            nombreAccion = "Salida al incendio";
        else if (CODIGO === "IN")
            nombreAccion = "En incendio";
    }
    return recursosSelected
        .map(recursoSelected => {
        const recursoId = recursoSelected.RECURSO.ID_RECURSO;
        const emergenciaSectorId = recursoSelected.ID_SECTOR;
        const idRecursoSectorEstadoTipo = recursoEstadoTipos.find(ret => removeTildes(ret.NOMBRE.toUpperCase()) === removeTildes(nombreAccion.toUpperCase()))?.ID_RECURSO_SECTOR_ESTADO_TIPO;
        if (!idRecursoSectorEstadoTipo)
            return null;
        // Calcular fecha, si no tiene fecha base
        const fecha = fechaBase
            ? fechaBase
            : arrayPeticiones.length
                ? DateService
                    .toDayjs(arrayPeticiones[arrayPeticiones.length - 1].recursoEstado.FECHA)
                    .add(2, DayjsUnit.Second)
                : DateService.getCurrentDayJs();
        const { condiciones, build } = getAccion[CODIGO](removeTildes(estadoInicial.toUpperCase()), emergenciaEstado, emergenciaSectorId, recursoId, idRecursoSectorEstadoTipo, fecha.format(FMT.display));
        if (!condiciones)
            return null;
        return build;
    });
}
export function checkEstadosIguales(estadosActuales) {
    const estadoReferencia = estadosActuales[0].RECURSO_SECTOR_ESTADO_TIPO;
    const sonEstadosIguales = estadosActuales.every(e => e.RECURSO_SECTOR_ESTADO_TIPO.ID_RECURSO_SECTOR_ESTADO_TIPO === estadoReferencia.ID_RECURSO_SECTOR_ESTADO_TIPO);
    if (!sonEstadosIguales)
        return false;
    return estadoReferencia;
}
